import React from 'react';
import { useTranslation } from 'react-i18next';
import { GridFourIcon } from '@fronton/icons-react';
import { BaseDesignRegistrationPanelProps, DesignRegistrationPanel } from 'common/components';
import { WINDOWS_ELEMENT_BLOCK } from '../../windows-constants';

export const WindowsDesignPanel: React.FC<BaseDesignRegistrationPanelProps> = ({
  isConsultationFormVisible,
  onConsultationSignupBtnClick,
}) => {
  const { t } = useTranslation();

  return (
    <DesignRegistrationPanel
      isConsultationFormVisible={isConsultationFormVisible}
      structure={{
        panel: {
          content: {
            leftIcon: GridFourIcon,
            iconColor: 'text-invert',
            iconType: 'duotone',
            text: t('design-panel.text'),
          },
          actionBlock: [{
            elementBlock: WINDOWS_ELEMENT_BLOCK,
            label: t('design-panel.button'),
            onClick: onConsultationSignupBtnClick,
            variant: 'accent',
          }],
        },
        mobilePanel: {
          mobileButton: {
            label: t('design-panel.button'),
            elementBlock: WINDOWS_ELEMENT_BLOCK,
            onClick: onConsultationSignupBtnClick,
          },
          content: {
            icon: GridFourIcon,
            iconColor: 'text-invert',
            iconType: 'duotone',
            text: t('design-panel.text') || '',
          },
          actionBlock: [{
            elementBlock: WINDOWS_ELEMENT_BLOCK,
            label: t('design-panel.button'),
            onClick: onConsultationSignupBtnClick,
            variant: 'accent',
          }],
        },
      }}
    />
  );
}
